<template>
  <section class="container section-scc-portal">
    <b-alert
        class="message-banner"
        :show="secretServiceLogin.visibilityWarning"
        variant="danger"
        dismissible
        @dismissed="secretServiceLogin.visibilityWarning=false"
    >
      <span class="span-login-page" v-if='secretServiceLogin.enableNumPassAttemptsAllowed'>
        You entered incorrect email or password. Try again. You have {{ secretServiceLogin.remainingAttempts }} more attempts left.
      </span>
      <span class="span-login-page" v-else>
        {{ warningMessage }}
      </span>
    </b-alert>
    <div id="container-page-title" style="display: flex;">
      <h1>Login</h1>
    </div>
    <p class="p-section">
      <span style="position: relative;">{{ loginUpperText }}</span>
    </p>
    <form
        @submit.prevent="requestLogin"
        name="scp_login_form"
        id="form-login-donor-portal-scc"
    >
      <div class="row container-item-form">
        <div class="container-input-form container-input-form-left col-sm">
          <label class="label-form-css" for="login-donor-portal-email">Email</label>
          <input
              type="text"
              class="form-control input-form-css"
              id="login-donor-portal-email"
              name="scp_username"
              aria-describedby="emailHelp"
              v-model="loginDonorData.login"
          >
          <small id="emailHelp" class="form-text text-muted">Required field.</small>
        </div>
        <div class="container-input-form container-input-form-right col-sm">
          <password-input
              error-message="The password you entered contains space(s), please remove it if it was added by mistake."
              message="Required field."
              label="Password"
              :outside-error-action = "objInvalid.password"
              name="loginDonor"
              @change_loginDonor="function(val){loginDonorData.password = val}"
              @focus_loginDonor="function(val){objInvalid.password = val}"
          />
        </div>
      </div>
      <button
          type="submit"
          class="button-section btn"
          id="login_donor_portal_submit"
          name="scp_login_form_submit"
          value="Log In"
      >
        SIGN IN
        <i class="fa fa-chevron-right" aria-hidden="true"></i>
      </button>

    </form>
    <div class="container container-block-links-section">
      <p class="p-section">
        <span style="position: relative;">{{ loginBottomText }}</span>
      </p>
      <div class="container-links-section" v-if="donorPortalSettings.dhq.enable">
        <router-link class="hover-item-a links-section" :to="donorPortalSettings.dhq.location" target="_blank">Create
          New Account
        </router-link>
      </div>
      <div class="container-links-section" v-else>
        <router-link class="hover-item-a links-section" to="/login-donor/create-new-account/">Create New Account
        </router-link>
      </div>
      <div class="container-links-section" v-if="donorPortalSettings.dhq.enable">
        <router-link class="hover-item-a links-section" to="/login-donor/forgot-password/" target="_blank">Forgot
          Password
        </router-link>
      </div>
      <div class="container-links-section" v-else>
        <router-link class="hover-item-a links-section" to="/login-donor/forgot-password/">Forgot Password</router-link>
      </div>
      <div class="container-links-section">
        <router-link class="hover-item-a links-section" to="/login-donor/forgot-donor-id/">Forgot Donor ID</router-link>
      </div>
      <div class="bottom-banner container-links-section" v-html="htmlPhoneMessage">
      </div>
    </div>
  </section>
</template>

<script>
import xlooLib from "../../../librarys/xlooLib";
import {mapState} from 'vuex';
import md5 from 'md5';
import moment from 'moment-timezone';
import PasswordInput from "../../elements/passwordInput";
export default {
  name: "loginDonor",
  components: {PasswordInput},
  data() {
    return {
      getData: {
        reloadPath: '',
      },
      loginDonorData: {
        login: '',
        password: '',
      },
      objInvalid: {
        login: false,
        password: false,
      },
      warningMessage: 'Your account is blocked for 60 minutes. Wait or contact the administrator',
      htmlPhoneMessage: '',
      secretServiceLogin: {
        counterTime: 5,
        visibilityWindowCounter: false,
        remainingAttempts: 0,
        visibilityWarning: false,
        minRange: 2,
        maxRange: 5,
        enableNumPassAttemptsAllowed: false,
        enableBeforeReAuthorization: false,
      },
    }
  },
  computed: {
    ...mapState({
      donorPortalSettings: state => state.settingsAndCustomize.donorPortalSettings,
      portalPhone: state => state.settingsAndCustomize.siteCustomizationData.headerFooter.phone,
      phoneMessage: state => state.settingsAndCustomize.siteCustomizationData.messages.supportsPhone,
      loginUpperText: state => state.settingsAndCustomize.siteCustomizationData.messages.loginUpperText,
      loginBottomText: state => state.settingsAndCustomize.siteCustomizationData.messages.loginBottomText,
    }),
  },
  created() {


    this.htmlPhoneMessage = '<p class="p-section">' + this.phoneMessage + '</p>'
    const linkPhone =   '<span style="position: relative">'
                          + '<a className="hover-item-a links-section phone-link" href="tel:' + this.portalPhone + '">'
                          + this.portalPhone
                          + '</a>'
                          + '</span>'
    this.htmlPhoneMessage =  this.htmlPhoneMessage.replace('$PhoneSupport', linkPhone)

    if(typeof this.$router.currentRoute.query.reloadPath !== 'undefined'){
      this.getData.reloadPath = this.$router.currentRoute.query.reloadPath
      this.$root.$emit('messageBox',
          {
            timeShow: 3000,
            typeColor: "success",
            textMessage: "Login timed out. Please login again.",
          })
    }
  },
  methods: {
    async requestLogin() {
      if (!this.checkCredentials()) {
        return false
      }
      const dataRequest = {
        action: 'restartLoginDonor',
        login: this.loginDonorData.login,
        passwordMd5: md5(this.loginDonorData.password).toUpperCase(),
      }

      this.$root.$emit("showSpinner");
      const resReqLogin = await this.$store.dispatch("auth/SET_loginDonor", dataRequest);
      this.$root.$emit("hideSpinner");

      switch (resReqLogin.status) {
        case 'fail':
          this.modalCounterTime(resReqLogin.message)
          break
        case 'ok':
          if (this.donorPortalSettings.dhq.enable) {
            let timeUpdateToken = moment(moment(new Date()).format('YYYY-MM-DD HH:mm:ss'))
                .add((Number(resReqLogin.dataDhq[1].value) - 30), 's')
                .format('YYYY-MM-DD HH:mm:ss');
            xlooLib.setLocalStorage("logged_on_portal", true);
            xlooLib.setLocalStorage("hash", resReqLogin.dataDhq[0].value);
            xlooLib.setLocalStorage("time_update_token", timeUpdateToken);
            xlooLib.setLocalStorage("token_duration_update", (Number(resReqLogin.dataDhq[1].value) - 10));
          }
          // eslint-disable-next-line no-case-declarations
          const idSession = typeof xlooLib.getCookie('PHPSESSIDPV')!=="undefined"?xlooLib.getCookie('PHPSESSIDPV'):true //for work dev version var=true
          this.$store.commit('auth/set_authDonor', idSession)
          if(this.getData.reloadPath ===''){
            await this.$router.push({name: 'myDonations'})
          } else {
            console.log ('this.getData  else ===', this.getData.reloadPath)
 //           const pathReload =
            await this.$router.push({path: this.getData.reloadPath})
          }
          break
      }
    },

    checkCredentials() {
      if (this.loginDonorData.login === '') {
        this.errorAlert('Login - Required field');
        this.objInvalid.login = true;
        return false
      }
      if (this.loginDonorData.password === '') {
        this.errorAlert('Password - Required field');
        this.objInvalid.password = true;
        return false
      }
      let reEmail = new RegExp('^([A-Za-z0-9_\\-\\.])+\\@([A-Za-z0-9_\\-\\.])+\\.([A-Za-z]{2,4})$');
      if (!reEmail.test(this.loginDonorData.login)) {
        this.errorAlert('Check Login');
        return false
      }
      return true
    },

    modalCounterTime(message) {
      this.warningMessage = message;
      this.secretServiceLogin.remainingAttempts = --this.secretServiceLogin.remainingAttempts;
      if (this.secretServiceLogin.remainingAttempts < 1 && this.secretServiceLogin.enableNumPassAttemptsAllowed) {
        this.$router.push({name: 'home'})
      }
      this.secretServiceLogin.visibilityWarning = true;
      if (this.secretServiceLogin.enableBeforeReAuthorization) {
        let timeOut;
        timeOut = this.getRandomInt(this.secretServiceLogin.minRange, this.secretServiceLogin.maxRange);
        this.secretServiceLogin.counterTime = timeOut;
        this.secretServiceLogin.visibilityWindowCounter = true;

        this.showModalCounterTime(timeOut, this.secretServiceLogin.remainingAttempts);
      }
    },
    showModalCounterTime(timeOut) {
      setTimeout(() => {
        --timeOut;
        if (timeOut === 0) {
          this.secretServiceLogin.visibilityWindowCounter = false;
          this.secretServiceLogin.visibilityWarning = false;
        } else {
          this.secretServiceLogin.counterTime = timeOut;
          this.showModalCounterTime(timeOut);
        }
      }, 1000);
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(++max);
      return Math.floor(Math.random() * (max - min)) + min;
    },
    errorAlert(message){
      this.$root.$emit('messageBox',
        {
          timeShow: 0,
          typeColor: "danger",
          textMessage: message,
        })
    },
  }
}
</script>

<style scoped>
.container-block-links-section{
  margin-top: 30px;
  padding-left: 0;
}
.container-links-section {
  margin: 15px 0;
  position: relative;
  text-decoration: none;
  width: max-content;
}
.links-section {
  color: var(--BasicFontColor);
  font-size: 1rem;
  text-decoration: none;
  font-weight: 600;
}
.links-section:hover {
  color: var(--ButtonColor);
  text-decoration: none;
}
.hover-item-a:focus:before, .hover-item-a:hover:before {
  -webkit-transform: scaleX(1);
  -ms-transform: scaleX(1);
  transform: scaleX(1);
  -webkit-transform-origin: 0 50%;
  -ms-transform-origin: 0 50%;
  transform-origin: 0 50%;
}
.hover-item-a:before {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
  -webkit-transform: scaleX(0);
  -ms-transform: scaleX(0);
  transform: scaleX(0);
  height: .125rem;
  bottom: .125rem;
  left: .0625rem;
  top: 1.25rem;
  background-color: var(--BasicFontColor);
  -webkit-transform-origin: 100% 50%;
  -ms-transform-origin: 100% 50%;
  transform-origin: 100% 50%;
  transition: -webkit-transform .4s cubic-bezier(.23, 1, .32, 1);
  transition: transform .4s cubic-bezier(.23, 1, .32, 1);
  transition: transform .4s cubic-bezier(.23, 1, .32, 1), -webkit-transform .4s cubic-bezier(.23, 1, .32, 1);
}
.phone-link{
  display: inline-block;
}
.p-section {
  color: inherit;
  font-size: 1rem;
}
</style>
